/**
 * forwarda i log client side al backend
 *
 */
if (!window.console) {
  // retrofit
  window.console = {
    log: function () {},
  };
}

window.consolle = new BrumConsolle();

function BrumConsolle() {
  /**
   * Monolog values
   */
  var DEBUG = 100;
  var INFO = 200;
  var NOTICE = 250;
  var WARNING = 300;
  var ERROR = 400;
  var CRITICAL = 500;
  var ALERT = 550;
  var EMERGENCY = 600;
  var IS_LOCALHOST = window.location.href.indexOf("localhost") !== -1;

  function forward_log(message, context, level) {
    context = context ? context : {};
    context.href = window.location.href;
    if (typeof message !== "string") {
      context["message_not_string"] = message;
      message = "passato un message che non  e' string, usare context!";
    }

    if (IS_LOCALHOST) {
      console.log(level);
      console.log(message);
      console.log(context);
    }
    /*
    $.ajax( {
      url        : "/log",
      method     : "POST",
      contentType: "application/json; charset=UTF-8",
      data       : JSON.stringify( {
        message: message,
        level  : level,
        context: context
      } )
    } );
        */
  }

  return {
    log: function (message, context) {
      // questo livello di verbosita' non viene inoltrato
      if (IS_LOCALHOST) {
        arguments.length >= 1 ? console.log(message) : "";
        arguments.length == 2 ? console.log(context) : "";
      }
    },
    debug: function (message, context) {
      forward_log(message, context, DEBUG);
    },
    info: function (message, context) {
      forward_log(message, context, INFO);
    },
    notice: function (message, context) {
      forward_log(message, context, NOTICE);
    },
    warn: function (message, context) {
      forward_log(message, context, WARNING);
    },
    err: function (message, context) {
      forward_log(message, context, ERROR);
    },
    critical: function (message, context) {
      forward_log(message, context, CRITICAL);
    },
    alert: function (message, context) {
      forward_log(message, context, ALERT);
    },
    omg: function (message, context) {
      forward_log(message, context, EMERGENCY);
    },
  };
}
